/**
 * Created by sswaminathan on 1/23/22
 * File: AddonListings
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css


/**
 *   TODO: Brief what is this component/class do
 */
import { useEffect, useState } from 'react'
import { groupBy } from 'lodash'
import CheckBoxComponent from '../../dataInput/CheckBoxComponent'
import DualNetworkAddonListing from './DualNetworkAddonListing'
import InputComponent from './sections/InputComponent'
import SectionHeaders from './sections/SectionHeaders'

const AddonListings = (props) => {
  const { itemList, allocation, isBundle, indexKey, ...rest } = props
  const [dualNetworkAddons, setDualNetworkAddons] = useState({})
  const [dualNetworkKeys, setDualNetworkKeys] = useState([])
  const { selectedTreeNode, instancesKeyBy } = rest
  const { isBundleDisabled, setBundleDisabled } = useState(false)
  useEffect(() => {
    const dualNetworkAddons = itemList?.filter((elem) => elem.isDualNetwork)
    const groupedAddons = groupBy(dualNetworkAddons, 'app_id')
    setDualNetworkAddons(groupedAddons)
    setDualNetworkKeys(Object.keys(groupedAddons))
  }, [itemList])

  return (<>
    {dualNetworkKeys.length > 0 && <DualNetworkAddonListing {...{ allocation, dualNetworkAddons, dualNetworkKeys, ...rest }} />}
    {(dualNetworkKeys.length === 0 && itemList?.length > 0 && !isBundle) && <SectionHeaders {...{ ...rest }} />}
    {isBundle && <div className={'tw-mt-2 tw-ml-2'}> <CheckBoxComponent
      {...{
        app_id: itemList[0]?.app_id,
        allocation,
        allowDisable: false,
        setCheckBoxStatus: setBundleDisabled,
        label: itemList[0]?.bundle_display_name,
        isBundle,
        product: itemList[0],
        ...rest }} /></div>}
    {itemList?.length > 0 && itemList.map((product, index) => {
      const existingInstance = instancesKeyBy ? instancesKeyBy[selectedTreeNode?.id]?.some(each => each.app_id === product.app_id) : undefined
      const productOverride = indexKey === 'products' ? product.license_type.includes('-MU') ? rest.mobile : rest.remote : {}
      return (
        (!product.isDualNetwork && product.display) &&
          <InputComponent
            {...{
              product,
              allocation,
              existingInstance,
              isBundleDisabled,
              isBundle,
              indexKey,
              ...rest,
              ...productOverride }}
            key={`${index}${indexKey}`}/>
      )
    })}
  </>)
}

AddonListings.propTypes = {}
export default AddonListings
